import Grid from "@mui/material/Unstable_Grid2";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";

interface VitalSignsParameterRowProps {
    label1: string;
    label2?: string;
    children: React.ReactNode;
    noBorder?: boolean;
}

export const VitalSignsParameterRow = ({
    label1,
    label2,
    children,
    noBorder = false
}: VitalSignsParameterRowProps) => {
    return (
        <Grid
            container
            alignItems="center"
            sx={{ borderBottom: noBorder ? "none" : "1px solid #E0E0E0", py: 1.5, width: "100%" }}
        >
            {/* Labels */}
            <Grid xs={12} sm={4} md={4} container>
                <Grid xs={label2 ? 6 : 12}>
                    <ByzMuiTypography sx={{ marginLeft: "10px" }}>
                        {label1}
                    </ByzMuiTypography>
                </Grid>
                {label2 && (
                    <Grid xs={6}>
                        <ByzMuiTypography>
                            {label2}
                        </ByzMuiTypography>
                    </Grid>
                )}
            </Grid>

            {/* Inputs */}
            <Grid xs={12} sm={8} md={8} container spacing={2}>
                {children}
            </Grid>
        </Grid>
    );
};
